import { render, staticRenderFns } from "./CommonOverlay.vue?vue&type=template&id=12b19e58&scoped=true"
import script from "./CommonOverlay.vue?vue&type=script&lang=js"
export * from "./CommonOverlay.vue?vue&type=script&lang=js"
import style0 from "./CommonOverlay.vue?vue&type=style&index=0&id=12b19e58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b19e58",
  null
  
)

export default component.exports